import React from "react";
import styled from "styled-components";
import {Research, ResearchSplash} from "../container/Research";

const Root = styled.div``;

export const ResearchPage = () => {
  return (
    <Root>
      <ResearchSplash />
      <Research />
    </Root>
  );
}
